"use strict";

exports.__esModule = true;
var _DeviceScreenToolbar = require("./DeviceScreenToolbar");
Object.keys(_DeviceScreenToolbar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceScreenToolbar[key]) return;
  exports[key] = _DeviceScreenToolbar[key];
});